import { toPragueLocaleString } from './datetime'

export type ParsedPhotoTimestamp = {
  date?: Date
  label: string
}

// Camera filenames look like:
//   camera-2026-04-15T17:07:22.498607183+00:00.jpg
// JS `Date` cannot consume the nanosecond fraction, so we truncate it to the
// first three digits (milliseconds) before parsing.
const FILENAME_RE = /^camera-(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d+))?(Z|[+-]\d{2}:?\d{2})?\.jpe?g$/i

export const parsePhotoTimestamp = (filenameOrUrl: string): ParsedPhotoTimestamp => {
  const filename = filenameOrUrl.split('/').pop() ?? filenameOrUrl
  const match = FILENAME_RE.exec(filename)
  if (!match) return { label: filename }

  const [, base, fraction, tz] = match
  const ms = fraction ? `.${fraction.slice(0, 3).padEnd(3, '0')}` : ''
  const isoCandidate = `${base}${ms}${tz ?? 'Z'}`
  const date = new Date(isoCandidate)
  if (Number.isNaN(date.getTime())) return { label: filename }

  return {
    date,
    label: toPragueLocaleString(date, { second: '2-digit' }),
  }
}
